import { render, staticRenderFns } from "./AppPlaceholderHorizontal.vue?vue&type=template&id=5aada244&"
import script from "./AppPlaceholderHorizontal.vue?vue&type=script&lang=js&"
export * from "./AppPlaceholderHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports